import { plainDate } from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const forecastAdjustmentPreviewMode = [
  "initial",
  "revise",
  "regenerate",
] as const;
export type ForecastAdjustmentPreviewMode =
  (typeof forecastAdjustmentPreviewMode)[number];

const PreviousForecastAdjustment_ = z.object({
  date: plainDate(),
  delta: z.number().int(),
});
export interface PreviousForecastAdjustment extends z.infer<
  typeof PreviousForecastAdjustment_
> {}
export const PreviousForecastAdjustment: z.ZodType<PreviousForecastAdjustment> =
  PreviousForecastAdjustment_;

const ForecastAdjustmentPreviewPoint_ = z.object({
  date: plainDate(),
  baselinePrediction: z.number(),
  existingAdjustment: z.number().int(),
  proposedDelta: z.number().int(),
  proposedAdjustment: z.number().int(),
  adjustedPrediction: z.number(),
});
export interface ForecastAdjustmentPreviewPoint extends z.infer<
  typeof ForecastAdjustmentPreviewPoint_
> {}
export const ForecastAdjustmentPreviewPoint: z.ZodType<ForecastAdjustmentPreviewPoint> =
  ForecastAdjustmentPreviewPoint_;

export const generateForecastAdjustmentPreview = {
  name: "generateForecastAdjustmentPreview" as const,
  input: z.object({
    sku: z.string().min(1),
    productTitle: z.string().nullable().optional(),
    prompt: z.string().min(1),
    startDate: plainDate(),
    endDate: plainDate(),
    mode: createEnum(forecastAdjustmentPreviewMode).default("initial"),
    previousExplanation: z.string().nullable().optional(),
    previousAdjustments: z.array(PreviousForecastAdjustment).default([]),
  }),
  output: z.object({
    sku: z.string(),
    explanation: z.string(),
    startDate: plainDate(),
    endDate: plainDate(),
    baselineTotal: z.number(),
    existingAdjustedTotal: z.number(),
    proposedAdjustedTotal: z.number(),
    proposedDeltaTotal: z.number(),
    adjustments: z.array(ForecastAdjustmentPreviewPoint),
  }),
};
